
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9TcxU", function(module, exports) {

$parcel$export(module.exports, "createPayloads", () => $f9c8e27bd7d2e1a5$export$51b606e6d67c2231);
$parcel$export(module.exports, "createExperimentalMetricsPayload", () => $f9c8e27bd7d2e1a5$export$6410c9ddb2ab201);

var $fceQU = parcelRequire("fceQU");

var $eGOwo = parcelRequire("eGOwo");

var $65RK5 = parcelRequire("65RK5");

var $hQ2Np = parcelRequire("hQ2Np");

var $lDihq = parcelRequire("lDihq");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $2OYCL = parcelRequire("2OYCL");

var $6whQo = parcelRequire("6whQo");

var $d2S0J = parcelRequire("d2S0J");

var $8tW4o = parcelRequire("8tW4o");

var $iKhRZ = parcelRequire("iKhRZ");

var $2QO3b = parcelRequire("2QO3b");

var $3jJlZ = parcelRequire("3jJlZ");

var $dpm9i = parcelRequire("dpm9i");

var $gzgMP = parcelRequire("gzgMP");

var $8IWpZ = parcelRequire("8IWpZ");

var $gA3op = parcelRequire("gA3op");

var $cu6g7 = parcelRequire("cu6g7");

var $7E8AF = parcelRequire("7E8AF");

var $exlmL = parcelRequire("exlmL");

var $jvGVe = parcelRequire("jvGVe");

var $8XAiV = parcelRequire("8XAiV");

var $bAhKB = parcelRequire("bAhKB");

var $8PHbo = parcelRequire("8PHbo");

var $lAaBI = parcelRequire("lAaBI");

var $6ilbC = parcelRequire("6ilbC");

var $hmVXh = parcelRequire("hmVXh");

var $5G7DY = parcelRequire("5G7DY");

var $7Qg5s = parcelRequire("7Qg5s");

var $6fyPV = parcelRequire("6fyPV");
function $f9c8e27bd7d2e1a5$var$getUfoNameOverride(interaction) {
    const { ufoName: ufoName, apdex: apdex } = interaction;
    try {
        const ufoNameOverrides = (0, $jcIvM.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            const metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    } catch (e) {
        return ufoName;
    }
}
function $f9c8e27bd7d2e1a5$var$getEarliestLegacyStopTime(interaction, labelStack) {
    let earliestLegacyStopTime = null;
    interaction.apdex.forEach((a)=>{
        if (!a?.stopTime) return;
        if (!(0, $cu6g7.labelStackStartWith)(a.labelStack ?? [], labelStack)) return;
        if (a.stopTime > interaction.start && (earliestLegacyStopTime ?? a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function $f9c8e27bd7d2e1a5$var$getBm3EndTimeOrFallbackValue(interaction, labelStack = [], fallbackValue = interaction.end) {
    if (interaction.type === 'press') return fallbackValue;
    return $f9c8e27bd7d2e1a5$var$getEarliestLegacyStopTime(interaction, labelStack) ?? fallbackValue;
}
function $f9c8e27bd7d2e1a5$var$getPageVisibilityUpToTTI(interaction) {
    const { start: start } = interaction;
    const bm3EndTimeOrInteractionEndTime = $f9c8e27bd7d2e1a5$var$getBm3EndTimeOrFallbackValue(interaction);
    return (0, $8tW4o.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
function $f9c8e27bd7d2e1a5$var$getVisibilityStateFromPerformance(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
}
function $f9c8e27bd7d2e1a5$var$getMoreAccuratePageVisibilityUpToTTI(interaction) {
    const old = $f9c8e27bd7d2e1a5$var$getPageVisibilityUpToTTI(interaction);
    const tti = $f9c8e27bd7d2e1a5$var$getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    const buffered = $f9c8e27bd7d2e1a5$var$getVisibilityStateFromPerformance(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $f9c8e27bd7d2e1a5$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) {
    const old = (0, $bAhKB.default)(interaction);
    const buffered = $f9c8e27bd7d2e1a5$var$getVisibilityStateFromPerformance(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $f9c8e27bd7d2e1a5$var$getResourceTimings(start, end) {
    return $dpm9i.getResourceTimings(start, end) ?? undefined;
}
function $f9c8e27bd7d2e1a5$var$getBundleEvalTimings(start) {
    return $lDihq.getBundleEvalTimings(start);
}
function $f9c8e27bd7d2e1a5$var$getSSRPhaseSuccess(type) {
    return type === 'page_load' ? $gA3op.getSSRPhaseSuccess() : undefined;
}
function $f9c8e27bd7d2e1a5$var$getSSRFeatureFlags(type) {
    return type === 'page_load' ? $gA3op.getSSRFeatureFlags() : undefined;
}
function $f9c8e27bd7d2e1a5$var$getPPSMetrics(interaction) {
    const { start: start, end: end } = interaction;
    const config = (0, $jcIvM.getConfig)();
    const interactionStatus = (0, $jvGVe.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $bAhKB.default)(interaction);
    const tti = interaction.apdex?.[0]?.stopTime;
    const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    const PPSMetricsAtTTI = tti !== undefined ? (0, $65RK5.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    const PPSMetricsAtTTAI = ttai !== undefined ? (0, $65RK5.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if ((0, $eGOwo.fg)('platform_ufo_remove_deprecated_config_fields')) {
        if (PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    } else {
        if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
        if (PPSMetricsAtTTI !== null) return {
            ...PPSMetricsAtTTI,
            'metrics@ttai': PPSMetricsAtTTAI
        };
    }
    return {};
}
function $f9c8e27bd7d2e1a5$var$getSSRProperties(type) {
    const ssrPhases = $f9c8e27bd7d2e1a5$var$getSSRPhaseSuccess(type);
    return {
        'ssr:success': ssrPhases?.done != null ? ssrPhases.done : (0, $5G7DY.default)(type),
        'ssr:featureFlags': $f9c8e27bd7d2e1a5$var$getSSRFeatureFlags(type),
        ...ssrPhases?.earlyFlush != null ? {
            'ssr:earlyflush:success': ssrPhases.earlyFlush
        } : null,
        ...ssrPhases?.prefetch != null ? {
            'ssr:prefetch:success': ssrPhases.prefetch
        } : null
    };
}
function $f9c8e27bd7d2e1a5$var$getAssetsMetrics(interaction, SSRDoneTime) {
    try {
        const config = (0, $jcIvM.getConfig)();
        const { type: type } = interaction;
        const allowedTypes = [
            'page_load'
        ];
        const assetsConfig = config?.assetsConfig;
        if (!allowedTypes.includes(type) || !assetsConfig) // Skip if: type not allowed or assetsClassification isn't configured
        return {};
        const reporter = new (0, $hQ2Np.CHRReporter)();
        const resourceTimings = (0, $gzgMP.filterResourceTimings)(interaction.start, interaction.end);
        const assets = reporter.get(resourceTimings, assetsConfig, SSRDoneTime);
        if (assets) // Only add assets in case it exists
        return {
            'event:assets': assets
        };
        return {};
    } catch (error) {
        // Skip CHR in case of error
        return {};
    }
}
function $f9c8e27bd7d2e1a5$var$getTracingContextData(interaction) {
    const { trace: trace, start: start } = interaction;
    let tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
}
function $f9c8e27bd7d2e1a5$var$optimizeCustomData(interaction) {
    const { customData: customData, cohortingCustomData: cohortingCustomData, legacyMetrics: legacyMetrics } = interaction;
    const customDataMap = customData.reduce((result, { labelStack: labelStack, data: data })=>{
        const label = (0, $cu6g7.stringifyLabelStackFully)(labelStack);
        const value = result.get(label)?.data ?? {};
        result.set(label, {
            labelStack: (0, $cu6g7.optimizeLabelStack)(labelStack, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    // Merge cohorting custom data into the same map
    if (cohortingCustomData && cohortingCustomData.size > 0) {
        const label = (0, $cu6g7.stringifyLabelStackFully)(interaction.labelStack ?? []);
        const value = customDataMap.get(label)?.data ?? {};
        customDataMap.set(label, {
            labelStack: (0, $cu6g7.optimizeLabelStack)(interaction.labelStack ?? [], (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, Object.fromEntries(cohortingCustomData))
        });
    }
    if (legacyMetrics) {
        const legacyMetricsFiltered = legacyMetrics.filter((item)=>item.type === 'PAGE_LOAD').reduce((result, currentValue)=>{
            for (const [key, value] of Object.entries(currentValue.custom || {})){
                const label = (0, $cu6g7.stringifyLabelStackFully)([]);
                const labelValue = result.get(label)?.data ?? {};
                result.set(label, {
                    labelStack: (0, $cu6g7.optimizeLabelStack)([], (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    data: Object.assign(labelValue, {
                        [key]: value
                    })
                });
            }
            return result;
        }, new Map());
        return [
            ...customDataMap.values(),
            ...legacyMetricsFiltered.values()
        ];
    }
    return [
        ...customDataMap.values()
    ];
}
function $f9c8e27bd7d2e1a5$var$optimizeReactProfilerTimings(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $cu6g7.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $cu6g7.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
function $f9c8e27bd7d2e1a5$var$optimizeRedirects(redirects, interactionStart) {
    let lastRedirectTime = interactionStart;
    const updatedRedirects = redirects.sort((a, b)=>a.time - b.time).reduce((result, redirect)=>{
        const { fromInteractionName: fromInteractionName, time: time } = redirect;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function $f9c8e27bd7d2e1a5$var$optimizeHoldInfo(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $cu6g7.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $cu6g7.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}
function $f9c8e27bd7d2e1a5$var$optimizeSpans(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $cu6g7.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
function $f9c8e27bd7d2e1a5$var$optimizeRequestInfo(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $cu6g7.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
function $f9c8e27bd7d2e1a5$var$optimizeCustomTimings(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}
function $f9c8e27bd7d2e1a5$var$optimizeMarks(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $cu6g7.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}
function $f9c8e27bd7d2e1a5$var$optimizeApdex(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $cu6g7.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}
function $f9c8e27bd7d2e1a5$var$objectToArray(obj = {}) {
    return Object.keys(obj).reduce((result, key)=>{
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, []);
}
function $f9c8e27bd7d2e1a5$var$getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    const submetricsTimings = submetrics.filter((item)=>{
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map((item)=>{
        let childSubmetrics;
        const newKey = `include/${item.key}`;
        if (item.submetrics) childSubmetrics = $f9c8e27bd7d2e1a5$var$getBM3SubmetricsTimings(item.submetrics);
        return {
            [newKey]: {
                endTime: item.stop - item.start,
                startTime: item.start
            },
            ...childSubmetrics ? childSubmetrics : {}
        };
    });
    return submetricsTimings;
}
function $f9c8e27bd7d2e1a5$var$getBm3TrackerTimings(interaction) {
    const interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    const legacyMetrics = interactionLegacyMetrics.map((item)=>{
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: item.config?.type,
            reactUFOName: item.config?.reactUFOName,
            fmp: item.marks?.['fmp'] || item.stop,
            source: 'bm3',
            timings: (0, $6whQo.getBm3Timings)(item.marks, item.config.timings),
            submetrics: $f9c8e27bd7d2e1a5$var$getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter((item)=>!!item.type);
    return {
        legacyMetrics: legacyMetrics
    };
}
function $f9c8e27bd7d2e1a5$var$getStylesheetMetrics() {
    try {
        const doc = (0, $fceQU.getDocument)();
        if (!doc) return {};
        const stylesheets = Array.from(doc.styleSheets);
        const stylesheetCount = stylesheets.length;
        const cssrules = Array.from(doc.styleSheets).reduce((acc, item)=>{
            // Other domain stylesheets throw a SecurityError
            try {
                return acc + item.cssRules.length;
            } catch (e) {
                return acc;
            }
        }, 0);
        const styleElements = doc.querySelectorAll('style').length;
        const styleProps = doc.querySelectorAll('[style]');
        const styleDeclarations = Array.from(doc.querySelectorAll('[style]')).reduce((acc, item)=>{
            try {
                if ('style' in item) return acc + item.style.length;
                else return acc;
            } catch (e) {
                return acc;
            }
        }, 0);
        return {
            'ufo:stylesheets': stylesheetCount,
            'ufo:styleElements': styleElements,
            'ufo:styleProps': styleProps.length,
            'ufo:styleDeclarations': styleDeclarations,
            'ufo:cssrules': cssrules
        };
    } catch (e) {
        return {};
    }
}
let $f9c8e27bd7d2e1a5$var$regularTTAI;
let $f9c8e27bd7d2e1a5$var$expTTAI;
function $f9c8e27bd7d2e1a5$var$getErrorCounts(interaction) {
    return {
        'ufo:errors:globalCount': (0, $d2S0J.getGlobalErrorCount)(),
        'ufo:errors:count': interaction.errors.length
    };
}
async function $f9c8e27bd7d2e1a5$var$createInteractionMetricsPayload(interaction, interactionId, experimental, criticalPayloadCount, vcMetrics) {
    const interactionPayloadStart = performance.now();
    const config = (0, $jcIvM.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, knownSegments: knownSegments, rate: rate, type: type, abortReason: abortReason, routeName: routeName, featureFlags: featureFlags, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, responsiveness: responsiveness, unknownElementName: unknownElementName, unknownElementHierarchy: unknownElementHierarchy } = interaction;
    const pageVisibilityAtTTI = $f9c8e27bd7d2e1a5$var$getPageVisibilityUpToTTI(interaction);
    const pageVisibilityAtTTAI = (0, $bAhKB.default)(interaction);
    const segments = !(0, $eGOwo.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : knownSegments;
    const segmentTree = (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $cu6g7.buildSegmentTree)(segments.map((segment)=>segment.labelStack)) : {};
    const isDetailedPayload = pageVisibilityAtTTAI === 'visible';
    const isPageLoad = type === 'page_load';
    const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    const moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $f9c8e27bd7d2e1a5$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? $f9c8e27bd7d2e1a5$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) : null;
    const labelStack = interaction.labelStack ? {
        labelStack: (0, $cu6g7.optimizeLabelStack)(interaction.labelStack, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type))
    } : {};
    // Page Load
    const getInitialPageLoadSSRMetrics = ()=>{
        if (!isPageLoad) return {};
        const config = (0, $jcIvM.getConfig)();
        const SSRDoneTimeValue = (0, $hmVXh.default)(config);
        const SSRDoneTime = SSRDoneTimeValue !== undefined ? {
            SSRDoneTime: Math.round(SSRDoneTimeValue)
        } : {};
        return {
            ...SSRDoneTime,
            isBM3ConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp,
            isUFOConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime
        };
    };
    const pageLoadInteractionMetrics = getInitialPageLoadSSRMetrics();
    // Detailed payload. Page visibility = visible
    const getDetailedInteractionMetrics = (resourceTimings)=>{
        if (experimental || window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
        const spans = [
            ...interaction.spans,
            ...(0, $2QO3b.interactionSpans)
        ];
        (0, $2QO3b.interactionSpans).length = 0;
        return {
            errors: interaction.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $cu6g7.optimizeLabelStack)(labelStack, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: [
                ...interaction.holdActive.values()
            ],
            redirects: $f9c8e27bd7d2e1a5$var$optimizeRedirects(interaction.redirects, start),
            holdInfo: $f9c8e27bd7d2e1a5$var$optimizeHoldInfo(experimental ? interaction.holdExpInfo : interaction.holdInfo, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            spans: $f9c8e27bd7d2e1a5$var$optimizeSpans(spans, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: $f9c8e27bd7d2e1a5$var$optimizeRequestInfo(interaction.requestInfo, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: $f9c8e27bd7d2e1a5$var$optimizeCustomTimings(interaction.customTimings, start),
            bundleEvalTimings: $f9c8e27bd7d2e1a5$var$objectToArray($f9c8e27bd7d2e1a5$var$getBundleEvalTimings(start)),
            resourceTimings: $f9c8e27bd7d2e1a5$var$objectToArray(resourceTimings)
        };
    };
    // Page load & detailed payload
    const getPageLoadDetailedInteractionMetrics = ()=>{
        if (!isPageLoad || !isDetailedPayload) return {};
        const config = (0, $jcIvM.getConfig)();
        return {
            initialPageLoadExtraTimings: $f9c8e27bd7d2e1a5$var$objectToArray($iKhRZ.getTimings()),
            SSRTimings: config?.ssr?.getSSRTimings ? config.ssr.getSSRTimings() : $f9c8e27bd7d2e1a5$var$objectToArray($gA3op.getSSRTimings())
        };
    };
    if (experimental) $f9c8e27bd7d2e1a5$var$expTTAI = (0, $7Qg5s.default)(interaction);
    else $f9c8e27bd7d2e1a5$var$regularTTAI = (0, $7Qg5s.default)(interaction);
    const newUFOName = (0, $cu6g7.sanitizeUfoName)(ufoName);
    const resourceTimings = $f9c8e27bd7d2e1a5$var$getResourceTimings(start, end);
    const [finalVCMetrics, experimentalMetrics, paintMetrics] = await Promise.all([
        vcMetrics || await (0, $6fyPV.default)(interaction),
        experimental ? (0, $2OYCL.getExperimentalVCMetrics)(interaction) : Promise.resolve(undefined),
        (0, $8PHbo.getPaintMetricsToLegacyFormat)(type, end)
    ]);
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': experimental ? 'custom.experimental-interaction-metrics' : 'custom.interaction-metrics',
                'experience:name': newUFOName,
                // Include CPU usage monitoring data
                'event:cpu:usage': (0, $3jJlZ.createPressureStateReport)(interaction.start, interaction.end),
                'event:memory:usage': (0, $3jJlZ.createMemoryStateReport)(interaction.start, interaction.end),
                ...criticalPayloadCount !== undefined ? {
                    'ufo:multipayload': true,
                    'ufo:criticalPayloadCount': criticalPayloadCount
                } : {},
                // root
                ...(0, $exlmL.getBrowserMetadataToLegacyFormat)(),
                ...$f9c8e27bd7d2e1a5$var$getSSRProperties(type),
                ...$f9c8e27bd7d2e1a5$var$getAssetsMetrics(interaction, pageLoadInteractionMetrics?.SSRDoneTime),
                ...$f9c8e27bd7d2e1a5$var$getPPSMetrics(interaction),
                ...paintMetrics,
                ...(0, $8XAiV.getNavigationMetricsToLegacyFormat)(type),
                ...finalVCMetrics,
                ...experimentalMetrics,
                ...config.additionalPayloadData?.(interaction),
                ...$f9c8e27bd7d2e1a5$var$getTracingContextData(interaction),
                ...$f9c8e27bd7d2e1a5$var$getStylesheetMetrics(),
                ...$f9c8e27bd7d2e1a5$var$getErrorCounts(interaction),
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    featureFlags: featureFlags,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    apdex: $f9c8e27bd7d2e1a5$var$optimizeApdex(interaction.apdex, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    end: Math.round(end),
                    start: Math.round(start),
                    segments: (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : segments.map(({ labelStack: labelStack, ...others })=>({
                            ...others,
                            labelStack: (0, $cu6g7.optimizeLabelStack)(labelStack, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type))
                        })),
                    marks: $f9c8e27bd7d2e1a5$var$optimizeMarks(interaction.marks, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    customData: $f9c8e27bd7d2e1a5$var$optimizeCustomData(interaction),
                    reactProfilerTimings: $f9c8e27bd7d2e1a5$var$optimizeReactProfilerTimings(interaction.reactProfilerTimings, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    ...responsiveness ? {
                        responsiveness: responsiveness
                    } : {},
                    ...labelStack,
                    ...pageLoadInteractionMetrics,
                    ...getDetailedInteractionMetrics(resourceTimings),
                    ...getPageLoadDetailedInteractionMetrics(),
                    ...$f9c8e27bd7d2e1a5$var$getBm3TrackerTimings(interaction),
                    'metric:ttai': experimental ? $f9c8e27bd7d2e1a5$var$regularTTAI || $f9c8e27bd7d2e1a5$var$expTTAI : undefined,
                    'metric:experimental:ttai': $f9c8e27bd7d2e1a5$var$expTTAI,
                    ...unknownElementName ? {
                        unknownElementName: unknownElementName
                    } : {},
                    ...unknownElementHierarchy ? {
                        unknownElementHierarchy: unknownElementHierarchy
                    } : {}
                },
                'ufo:payloadTime': (0, $8IWpZ.roundEpsilon)(performance.now() - interactionPayloadStart)
            }
        }
    };
    if (experimental) {
        $f9c8e27bd7d2e1a5$var$regularTTAI = undefined;
        $f9c8e27bd7d2e1a5$var$expTTAI = undefined;
    }
    payload.attributes.properties['event:sizeInKb'] = (0, $lAaBI.default)(payload.attributes.properties);
    return payload;
}
async function $f9c8e27bd7d2e1a5$export$51b606e6d67c2231(interactionId, interaction) {
    const ufoNameOverride = $f9c8e27bd7d2e1a5$var$getUfoNameOverride(interaction);
    const modifiedInteraction = {
        ...interaction,
        ufoName: ufoNameOverride
    };
    const payloads = [];
    const isCriticalMetricsEnabled = (0, $eGOwo.fg)('platform_ufo_critical_metrics_payload');
    // Calculate VC metrics once to avoid duplicate expensive calculations
    const vcMetrics = await (0, $6fyPV.default)(interaction);
    // typeof Promise<CriticalMetricsPayload[]>
    const criticalMetricsPayloads = isCriticalMetricsEnabled ? await (0, $7E8AF.createCriticalMetricsPayloads)(interactionId, interaction, vcMetrics) : [];
    payloads.push(...criticalMetricsPayloads);
    const criticalPayloadCount = isCriticalMetricsEnabled ? criticalMetricsPayloads.length : undefined;
    const interactionMetricsPayload = await $f9c8e27bd7d2e1a5$var$createInteractionMetricsPayload(modifiedInteraction, interactionId, undefined, criticalPayloadCount, vcMetrics);
    payloads.push(interactionMetricsPayload);
    return payloads.filter(Boolean);
}
async function $f9c8e27bd7d2e1a5$export$6410c9ddb2ab201(interactionId, interaction) {
    const config = (0, $jcIvM.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const ufoName = (0, $cu6g7.sanitizeUfoName)(interaction.ufoName);
    const rate = (0, $jcIvM.getExperimentalInteractionRate)(ufoName, interaction.type);
    if (!(0, $2oAAJ.default)(rate)) return null;
    const pageVisibilityState = (0, $8tW4o.getPageVisibilityState)(interaction.start, interaction.end);
    if (pageVisibilityState !== 'visible') return null;
    const result = await $f9c8e27bd7d2e1a5$var$createInteractionMetricsPayload(interaction, interactionId, true);
    return result;
}

});
parcelRegister("hQ2Np", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $4f62b65b85e71c49$export$7d0d4cfb6455ffa5);

var $eGOwo = parcelRequire("eGOwo");

var $jVPIN = parcelRequire("jVPIN");
class $4f62b65b85e71c49$export$783d6618ee601ba {
    add(asset) {
        const encodedSize = asset.encodedSize || 0;
        const type = (0, $jVPIN.calculateTransferType)(asset.name, asset.initiatorType, asset.duration, asset.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += encodedSize;
        this.sizeTotal += encodedSize;
    }
    static makePayload(summary) {
        const { size: size, bundlesCount: bundlesCount, sizeTotal: sizeTotal } = summary;
        const cachedSize = size[0, $jVPIN.MEMORY_KEY] + size[0, $jVPIN.DISK_KEY];
        const sizeRatio = (0, $jVPIN.round)(cachedSize / summary.sizeTotal);
        return {
            size: sizeTotal,
            chr: sizeRatio,
            count: bundlesCount
        };
    }
    constructor(){
        this.bundles = {
            [(0, $jVPIN.MEMORY_KEY)]: 0,
            [(0, $jVPIN.DISK_KEY)]: 0,
            [(0, $jVPIN.NETWORK_KEY)]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [(0, $jVPIN.MEMORY_KEY)]: 0,
            [(0, $jVPIN.DISK_KEY)]: 0,
            [(0, $jVPIN.NETWORK_KEY)]: 0
        };
        this.sizeTotal = 0;
    }
}
class $4f62b65b85e71c49$export$7d0d4cfb6455ffa5 {
    get(resourceTimings, assetsConfig, SSRDoneTime) {
        try {
            if (resourceTimings === null) return null;
            resourceTimings.forEach((entry)=>{
                if (!(0, $jVPIN.checkIfTimingsAvailable)(entry)) return;
                const hasNanValues = (0, $eGOwo.fg)('platform_ufo_assets_check_for_nan') ? entry.encodedSize === undefined || entry.encodedSize === null : false;
                if (entry.encodedSize === entry.decodedSize || hasNanValues) // incorrectly reported or lack of size
                return;
                const type = (0, $jVPIN.getTypeOfRequest)(entry);
                if (!(assetsConfig.allowedTypes || this.defaultAllowedTypes).includes(type)) return;
                if (assetsConfig.classification.all) this.all.add(entry);
                if (assetsConfig.classification.allAtlassian({
                    entry: entry
                })) this.allAtlassian.add(entry);
                if (assetsConfig.classification.preloaded({
                    entry: entry,
                    SSRDoneTime: SSRDoneTime
                })) this.preloaded.add(entry);
            });
            if (this.all.bundlesCount === 0) return null;
            const CHRData = {
                all: $4f62b65b85e71c49$export$783d6618ee601ba.makePayload(this.all),
                allAtlassian: $4f62b65b85e71c49$export$783d6618ee601ba.makePayload(this.allAtlassian),
                preloaded: $4f62b65b85e71c49$export$783d6618ee601ba.makePayload(this.preloaded)
            };
            return CHRData;
        } catch (error) {
            return null;
        }
    }
    constructor(){
        this.all = new $4f62b65b85e71c49$export$783d6618ee601ba();
        this.allAtlassian = new $4f62b65b85e71c49$export$783d6618ee601ba();
        this.preloaded = new $4f62b65b85e71c49$export$783d6618ee601ba();
        this.defaultAllowedTypes = [
            'js'
        ];
    }
}

});
parcelRegister("jVPIN", function(module, exports) {

$parcel$export(module.exports, "MEMORY_KEY", () => $1d71e9c6901391b9$export$22f4983702ea2cc3);
$parcel$export(module.exports, "DISK_KEY", () => $1d71e9c6901391b9$export$d85e88075ae28804);
$parcel$export(module.exports, "NETWORK_KEY", () => $1d71e9c6901391b9$export$c46019be3f2161d7);
$parcel$export(module.exports, "calculateTransferType", () => $1d71e9c6901391b9$export$82deef6698791e4e);
$parcel$export(module.exports, "getTypeOfRequest", () => $1d71e9c6901391b9$export$d63396a1f85f70a0);
$parcel$export(module.exports, "checkIfTimingsAvailable", () => $1d71e9c6901391b9$export$c67eec4e6ad72694);
$parcel$export(module.exports, "round", () => $1d71e9c6901391b9$export$2077e0241d6afd3c);
const $1d71e9c6901391b9$export$5e1aa91d6932ddaa = [
    'script',
    'link',
    'other'
];
const $1d71e9c6901391b9$export$22f4983702ea2cc3 = 'mem';
const $1d71e9c6901391b9$export$d85e88075ae28804 = 'disk';
const $1d71e9c6901391b9$export$c46019be3f2161d7 = 'net';
function $1d71e9c6901391b9$export$82deef6698791e4e(name, type, duration, size) {
    if (!$1d71e9c6901391b9$export$5e1aa91d6932ddaa.includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    if ((size === undefined || size === 0) && duration === 0) return $1d71e9c6901391b9$export$22f4983702ea2cc3;
    if (size === 0 && duration > 0) return $1d71e9c6901391b9$export$d85e88075ae28804;
    if (size === undefined) return null;
    return $1d71e9c6901391b9$export$c46019be3f2161d7;
}
function $1d71e9c6901391b9$export$d63396a1f85f70a0({ name: name, initiatorType: type }) {
    let category = 'other';
    const urlWithoutQuery = name.split('?')[0];
    switch(type){
        case 'script':
            category = 'js';
            break;
        case 'link':
            if (urlWithoutQuery.endsWith('.css')) category = 'css';
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            break;
        case 'img':
            category = 'image';
            break;
        case 'font':
            category = 'font';
            break;
        default:
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            else if (urlWithoutQuery.endsWith('.css')) category = 'css';
            else if (urlWithoutQuery.match(/\.(woff|woff2|ttf|otf)$/)) category = 'font';
            else if (urlWithoutQuery.match(/\.(png|jpg|jpeg|gif|svg)$/)) category = 'image';
            break;
    }
    return category;
}
function $1d71e9c6901391b9$export$c67eec4e6ad72694(entry) {
    if (entry.decodedSize === 0 && entry.encodedSize === 0 && entry.requestStart === 0 && entry.responseStart === 0) return false;
    return true;
}
function $1d71e9c6901391b9$export$2077e0241d6afd3c(n) {
    if (isNaN(n)) return 0;
    return Math.round(n * 10000) / 10000;
}

});


parcelRegister("lDihq", function(module, exports) {

$parcel$export(module.exports, "configure", () => $ef37416f391f8125$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $ef37416f391f8125$export$2eda1519e91a4386);

var $8IWpZ = parcelRequire("8IWpZ");
let $ef37416f391f8125$var$config = null;
function $ef37416f391f8125$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $ef37416f391f8125$var$config = bundleEvalTimingConfiguration;
}
function $ef37416f391f8125$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $ef37416f391f8125$export$2eda1519e91a4386(interactionStartTime) {
    if ($ef37416f391f8125$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $ef37416f391f8125$var$config;
    const performance = $ef37416f391f8125$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $8IWpZ.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $8IWpZ.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("8IWpZ", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $8f6811d6996df949$export$56014375de40214b);
function $8f6811d6996df949$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("6whQo", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("dpm9i", function(module, exports) {

$parcel$export(module.exports, "getResourceTimings", () => $362e7deae9d7f39d$export$9eebb59359c2e9e5);

var $eGOwo = parcelRequire("eGOwo");

var $jcIvM = parcelRequire("jcIvM");

var $8IWpZ = parcelRequire("8IWpZ");

var $53lbp = parcelRequire("53lbp");

var $gzgMP = parcelRequire("gzgMP");
const $362e7deae9d7f39d$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $362e7deae9d7f39d$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $362e7deae9d7f39d$var$CACHE_NETWORK = 'network';
const $362e7deae9d7f39d$var$CACHE_MEMORY = 'memory';
const $362e7deae9d7f39d$var$CACHE_DISK = 'disk';
function $362e7deae9d7f39d$var$isCacheableType(url, type) {
    if ($362e7deae9d7f39d$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $362e7deae9d7f39d$var$calculateTransferType(name, type, duration, size) {
    if (!$362e7deae9d7f39d$var$isCacheableType(name, type)) return $362e7deae9d7f39d$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $362e7deae9d7f39d$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $362e7deae9d7f39d$var$CACHE_DISK;
    if (size === undefined) return null;
    return $362e7deae9d7f39d$var$CACHE_NETWORK;
}
function $362e7deae9d7f39d$var$getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
}
function $362e7deae9d7f39d$var$hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$362e7deae9d7f39d$var$isCacheableType(url, type) || url.includes('localhost') || !!$362e7deae9d7f39d$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
}
function $362e7deae9d7f39d$var$getReportedInitiatorTypes(xhrEnabled) {
    const ufoConfig = (0, $jcIvM.getConfig)();
    if (!ufoConfig?.allowedResources) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'other',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch',
            'other'
        ];
    }
    return ufoConfig.allowedResources;
}
function $362e7deae9d7f39d$var$evaluateAccessToResourceTimings(url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $362e7deae9d7f39d$var$getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
}
function $362e7deae9d7f39d$var$getNetworkData(item, eventStart, hasTimingHeaders = $362e7deae9d7f39d$var$evaluateAccessToResourceTimings) {
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart, requestStart: requestStart, serverTime: serverTime, networkTime: networkTime, encodedSize: encodedSize, decodedSize: decodedSize } = item;
    const ttfb = (0, $8IWpZ.roundEpsilon)(responseStart - eventStart);
    const requestStartRelative = (0, $8IWpZ.roundEpsilon)(requestStart - eventStart);
    if (!$362e7deae9d7f39d$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($362e7deae9d7f39d$var$isCacheableType(name, initiatorType)) {
        const transferType = $362e7deae9d7f39d$var$calculateTransferType(name, initiatorType, duration, transferSize);
        return {
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize,
            ...$362e7deae9d7f39d$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: (0, $eGOwo.fg)('ufo_return_relative_request_start') ? requestStartRelative : requestStart,
        ...$362e7deae9d7f39d$var$getSizeObject(transferSize)
    };
}
function $362e7deae9d7f39d$export$9eebb59359c2e9e5(interactionStart, interactionEnd) {
    const resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    const resources = (0, $gzgMP.filterResourceTimings)(interactionStart, interactionEnd);
    if (!resources?.length) return resourceTiming;
    const { xhrFilter: xhrFilter, sanitiseEndpoints: sanitiseEndpoints, mapResources: mapResources, hasTimingHeaders: hasTimingHeaders } = (0, $53lbp.getConfig)();
    const reportedInitiatorTypes = $362e7deae9d7f39d$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        if (initiatorType === 'other' && !name.includes('.js')) return;
        const url = $362e7deae9d7f39d$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url) return;
        if (resourceTiming[url]) {
            resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
            return;
        }
        resourceTiming[url] = {
            startTime: (0, $8IWpZ.roundEpsilon)(startTime - interactionStart),
            duration: (0, $8IWpZ.roundEpsilon)(duration),
            workerStart: Math.max((0, $8IWpZ.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, $8IWpZ.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType,
            ...$362e7deae9d7f39d$var$getNetworkData(item, interactionStart, hasTimingHeaders)
        };
    });
    return resourceTiming;
}

});
parcelRegister("53lbp", function(module, exports) {

$parcel$export(module.exports, "configure", () => $e21ca2f7e485b7e8$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $e21ca2f7e485b7e8$export$44487a86467333c3);

var $jcIvM = parcelRequire("jcIvM");
const $e21ca2f7e485b7e8$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $e21ca2f7e485b7e8$var$getAllowedParams() {
    const config = (0, $jcIvM.getConfig)();
    return config?.allowedResourcesParams || $e21ca2f7e485b7e8$var$defaultAllowedParams;
}
function $e21ca2f7e485b7e8$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $e21ca2f7e485b7e8$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $e21ca2f7e485b7e8$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $e21ca2f7e485b7e8$var$handleQueryParams(url);
    }
};
function $e21ca2f7e485b7e8$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $e21ca2f7e485b7e8$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $e21ca2f7e485b7e8$var$config = newConfig;
}
function $e21ca2f7e485b7e8$export$44487a86467333c3() {
    return $e21ca2f7e485b7e8$var$config;
}

});

parcelRegister("gzgMP", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $b75a77abbae91d5b$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $b75a77abbae91d5b$export$4138a729ef1db028);

var $8IWpZ = parcelRequire("8IWpZ");
const $b75a77abbae91d5b$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $b75a77abbae91d5b$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $b75a77abbae91d5b$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $8IWpZ.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $8IWpZ.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $8IWpZ.roundEpsilon)(entry.startTime),
            duration: (0, $8IWpZ.roundEpsilon)(entry.duration),
            fetchStart: (0, $8IWpZ.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $8IWpZ.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $8IWpZ.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $8IWpZ.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $8IWpZ.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $8IWpZ.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $b75a77abbae91d5b$var$getPerformanceObject();
        const PerformanceObserver = $b75a77abbae91d5b$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($b75a77abbae91d5b$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $b75a77abbae91d5b$export$bea963256235a63e.timings = resources.map((resource)=>$b75a77abbae91d5b$export$bea963256235a63e.transformResource(resource));
        $b75a77abbae91d5b$export$bea963256235a63e.observer = new PerformanceObserver($b75a77abbae91d5b$export$bea963256235a63e.addTimings);
        $b75a77abbae91d5b$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($b75a77abbae91d5b$export$bea963256235a63e.observer) {
            $b75a77abbae91d5b$export$bea963256235a63e.observer.disconnect();
            $b75a77abbae91d5b$export$bea963256235a63e.observer = null;
        }
        $b75a77abbae91d5b$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$b75a77abbae91d5b$export$bea963256235a63e.transformResource(entry));
        const overflow = $b75a77abbae91d5b$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $b75a77abbae91d5b$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $b75a77abbae91d5b$export$bea963256235a63e.maxSize;
            $b75a77abbae91d5b$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $b75a77abbae91d5b$export$bea963256235a63e.timings.push(...entries);
    }
};
function $b75a77abbae91d5b$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $b75a77abbae91d5b$export$4138a729ef1db028(startTime, endTime) {
    const performance = $b75a77abbae91d5b$var$getPerformanceObject();
    const PerformanceObserver = $b75a77abbae91d5b$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$b75a77abbae91d5b$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$b75a77abbae91d5b$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $b75a77abbae91d5b$export$bea963256235a63e.timings.filter((timing)=>$b75a77abbae91d5b$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("gA3op", function(module, exports) {

$parcel$export(module.exports, "configure", () => $b65e54b4ec190147$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $b65e54b4ec190147$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $b65e54b4ec190147$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $b65e54b4ec190147$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $b65e54b4ec190147$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $b65e54b4ec190147$export$1c4a9b5e6e22393d);

var $eGOwo = parcelRequire("eGOwo");
const $b65e54b4ec190147$var$NESTED_METRIC_SEPARATOR = '/';
function $b65e54b4ec190147$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $b65e54b4ec190147$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size && (0, $eGOwo.fg)('platform_ufo_ssr_size_field') ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $b65e54b4ec190147$var$SSR_PREFIX = 'ssr';
function $b65e54b4ec190147$var$mapKey(key) {
    if (key === 'total') return $b65e54b4ec190147$var$SSR_PREFIX;
    return `${$b65e54b4ec190147$var$SSR_PREFIX}${$b65e54b4ec190147$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $b65e54b4ec190147$var$config;
function $b65e54b4ec190147$export$8d21e34596265fa2(ssrConfig) {
    $b65e54b4ec190147$var$config = ssrConfig;
}
function $b65e54b4ec190147$export$bf7408e83532dcd0() {
    if (!$b65e54b4ec190147$var$config?.getTimings) return {};
    const timings = $b65e54b4ec190147$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($b65e54b4ec190147$var$filterEntry(entry[1])) acc[$b65e54b4ec190147$var$mapKey(entry[0])] = $b65e54b4ec190147$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $b65e54b4ec190147$export$c7ad864055e75537() {
    return !!$b65e54b4ec190147$var$config?.getDoneMark();
}
function $b65e54b4ec190147$export$5eade9354185583d() {
    return $b65e54b4ec190147$var$config?.getSsrPhaseSuccess?.();
}
function $b65e54b4ec190147$export$3def7672244bab0c() {
    return $b65e54b4ec190147$var$config?.getDoneMark() ?? undefined;
}
function $b65e54b4ec190147$export$1c4a9b5e6e22393d() {
    if (!$b65e54b4ec190147$var$config?.getFeatureFlags) return undefined;
    try {
        return $b65e54b4ec190147$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("7E8AF", function(module, exports) {

$parcel$export(module.exports, "createCriticalMetricsPayloads", () => $22a4677ff5a7962c$export$dbc5b5c3cadc26f7);

var $eGOwo = parcelRequire("eGOwo");

var $iqmAR = parcelRequire("iqmAR");

var $6pnNR = parcelRequire("6pnNR");
async function $22a4677ff5a7962c$export$dbc5b5c3cadc26f7(interactionId, interaction, vcMetrics) {
    const [rootPayload, segmentPayloads] = await Promise.all([
        (0, $iqmAR.createRootCriticalMetricsPayload)(interactionId, interaction, vcMetrics),
        (0, $eGOwo.fg)('platform_ufo_segment_critical_metrics') ? (0, $6pnNR.createSegmentMetricsPayloads)(interactionId, interaction) : []
    ]);
    return [
        rootPayload,
        ...segmentPayloads
    ].filter((v)=>v != null);
}

});
parcelRegister("iqmAR", function(module, exports) {

$parcel$export(module.exports, "createRootCriticalMetricsPayload", () => $20e9fc0f8f901f49$export$2b2c445402a6f795);

var $65RK5 = parcelRequire("65RK5");

var $jcIvM = parcelRequire("jcIvM");

var $8tW4o = parcelRequire("8tW4o");

var $cu6g7 = parcelRequire("cu6g7");

var $exlmL = parcelRequire("exlmL");

var $jEUmd = parcelRequire("jEUmd");

var $jvGVe = parcelRequire("jvGVe");

var $8XAiV = parcelRequire("8XAiV");

var $bAhKB = parcelRequire("bAhKB");

var $8PHbo = parcelRequire("8PHbo");

var $6ilbC = parcelRequire("6ilbC");

var $5G7DY = parcelRequire("5G7DY");

var $7Qg5s = parcelRequire("7Qg5s");

var $79aVI = parcelRequire("79aVI");

var $6fyPV = parcelRequire("6fyPV");
// Local utility functions
function $20e9fc0f8f901f49$var$getPageVisibilityUpToTTI(interaction) {
    const { start: start } = interaction;
    const bm3EndTimeOrInteractionEndTime = interaction.apdex?.[0]?.stopTime ?? interaction.end;
    return (0, $8tW4o.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
async function $20e9fc0f8f901f49$export$2b2c445402a6f795(interactionId, interaction, vcMetrics) {
    const config = (0, $jcIvM.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, rate: rate, type: type, abortReason: abortReason, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, holdInfo: holdInfo, responsiveness: responsiveness } = interaction;
    const pageVisibilityAtTTI = $20e9fc0f8f901f49$var$getPageVisibilityUpToTTI(interaction);
    const pageVisibilityAtTTAI = (0, $bAhKB.default)(interaction);
    const interactionStatus = (0, $jvGVe.default)(interaction);
    if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED') // To reduce payload sent from the client, we don't send critical perf metrics for non-success interactions
    return null;
    const newUFOName = (0, $cu6g7.sanitizeUfoName)(ufoName);
    // Get performance metrics
    const ttai = (0, $7Qg5s.default)(interaction);
    const paintMetrics = await (0, $8PHbo.default)(type, end);
    const navigationMetrics = (0, $8XAiV.default)(type);
    const ssrSuccess = (0, $5G7DY.default)(type);
    // Calculate BM3 metrics (TTI and FMP) directly
    const tti = (0, $79aVI.getTTI)(interaction, newUFOName);
    const fmp = (0, $jEUmd.getFMP)(interaction, newUFOName);
    // Get browser metadata (using compact nested format)
    const browserMetadata = (0, $exlmL.default)();
    const lighthouseMetrics = (0, $65RK5.getLighthouseMetrics)({
        start: start,
        stop: end
    });
    // Use provided vcMetrics or calculate if not provided
    const finalVCMetrics = vcMetrics || await (0, $6fyPV.default)(interaction);
    const ttvc = finalVCMetrics['ufo:vc:rev']?.map((revision)=>{
        if (revision['metric:vc90'] === null || revision.clean !== true) return null;
        return {
            revision: revision.revision,
            vc90: revision['metric:vc90']
        };
    }).filter((revision)=>revision != null);
    // find earliest hold
    const earliestHold = holdInfo?.reduce((a, b)=>{
        if (a && a.start < b.start) return a;
        return b;
    }, null);
    // Process cohorting custom data
    const cohortingCustomData = interaction.cohortingCustomData?.size ? Object.fromEntries(interaction.cohortingCustomData) : undefined;
    const properties = {
        // Basic metadata
        'event:hostname': window.location?.hostname || 'unknown',
        'event:product': config.product,
        'event:schema': '1.0.0',
        'event:region': config.region || 'unknown',
        'event:source': {
            name: 'react-ufo/web',
            version: (0, $6ilbC.LATEST_REACT_UFO_PAYLOAD_VERSION)
        },
        'experience:key': 'custom.ufo.critical-metrics',
        'experience:name': newUFOName,
        // Browser metadata (compact nested format)
        browser: browserMetadata.browser,
        device: browserMetadata.device,
        network: browserMetadata.network,
        time: browserMetadata.time,
        metrics: {
            fp: paintMetrics.fp,
            fcp: paintMetrics.fcp,
            lcp: paintMetrics.lcp,
            ttai: ttai,
            tti: tti,
            fmp: fmp,
            tbt: lighthouseMetrics['metric:tbt'],
            tbtObserved: lighthouseMetrics['metric:tbt:observed'],
            cls: lighthouseMetrics['metric:cls'],
            ttvc: ttvc ?? undefined,
            earliestHoldStart: earliestHold?.start ? Math.round(earliestHold.start - start) : undefined,
            inputDelay: responsiveness?.inputDelay ? Math.round(responsiveness.inputDelay) : undefined,
            inp: responsiveness?.experimentalInputToNextPaint ? Math.round(responsiveness.experimentalInputToNextPaint) : undefined,
            ...navigationMetrics && {
                navigation: navigationMetrics
            }
        },
        ...ssrSuccess !== undefined && {
            ssrSuccess: ssrSuccess
        },
        interactionId: interactionId,
        type: type,
        rate: rate,
        routeName: routeName ?? undefined,
        // Performance timings
        start: Math.round(start),
        end: Math.round(end),
        // Status and outcome
        status: interactionStatus.originalInteractionStatus,
        abortReason: abortReason,
        previousInteractionName: previousInteractionName,
        isPreviousInteractionAborted: isPreviousInteractionAborted,
        abortedByInteractionName: abortedByInteractionName,
        pageVisibilityAtTTI: pageVisibilityAtTTI ?? undefined,
        pageVisibilityAtTTAI: pageVisibilityAtTTAI,
        // Basic error count (not detailed error count)
        errorCount: interaction.errors.length,
        // Cohorting custom data
        ...Object.keys(cohortingCustomData || {}).length > 0 && {
            cohortingCustomData: cohortingCustomData
        }
    };
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: properties
        }
    };
    return payload;
}

});
parcelRegister("exlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $decc2100fdfc306f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getBrowserMetadataToLegacyFormat", () => $decc2100fdfc306f$export$adab82a5a24aa23e);

var $3nEAz = parcelRequire("3nEAz");
function $decc2100fdfc306f$export$2e2bcd8739ae039() {
    const data = {
        time: {
            localHour: 0,
            localDayOfWeek: 0,
            localTimezoneOffset: 0
        }
    };
    const now = new Date();
    data.time.localHour = now.getHours(); // returns the hours for this date according to local time
    data.time.localDayOfWeek = now.getDay(); // Sunday - Saturday : 0 - 6
    data.time.localTimezoneOffset = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (typeof navigator !== 'undefined' && navigator.userAgent != null) {
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser(navigator.userAgent);
        data.browser = {
            name: browser.getBrowserName(),
            version: browser.getBrowserVersion()
        };
    }
    if (typeof navigator !== 'undefined' && navigator.hardwareConcurrency != null) {
        if (!data.device) data.device = {};
        data.device.cpus = navigator.hardwareConcurrency;
    }
    if (typeof navigator !== 'undefined' && navigator.deviceMemory != null) {
        if (!data.device) data.device = {};
        data.device.memory = navigator.deviceMemory;
    }
    // eslint-disable-next-line compat/compat
    if (typeof navigator !== 'undefined' && navigator.connection != null) data.network = {
        effectiveType: navigator.connection.effectiveType,
        rtt: navigator.connection.rtt,
        downlink: navigator.connection.downlink
    };
    return data;
}
function $decc2100fdfc306f$export$adab82a5a24aa23e() {
    const metadata = $decc2100fdfc306f$export$2e2bcd8739ae039();
    const legacyFormat = {};
    // Time data
    legacyFormat['event:localHour'] = metadata.time.localHour;
    legacyFormat['event:localDayOfWeek'] = metadata.time.localDayOfWeek;
    legacyFormat['event:localTimezoneOffset'] = metadata.time.localTimezoneOffset;
    // Browser data
    if (metadata.browser) {
        legacyFormat['event:browser:name'] = metadata.browser.name;
        legacyFormat['event:browser:version'] = metadata.browser.version;
    }
    // Device data
    if (metadata.device) {
        if (metadata.device.cpus !== undefined) legacyFormat['event:cpus'] = metadata.device.cpus;
        if (metadata.device.memory !== undefined) legacyFormat['event:memory'] = metadata.device.memory;
    }
    // Network data
    if (metadata.network) {
        legacyFormat['event:network:effectiveType'] = metadata.network.effectiveType;
        legacyFormat['event:network:rtt'] = metadata.network.rtt;
        legacyFormat['event:network:downlink'] = metadata.network.downlink;
    }
    return legacyFormat;
}

});

parcelRegister("jEUmd", function(module, exports) {

$parcel$export(module.exports, "getFMP", () => $1f2598c80baecd06$export$b98bf736a4892f95);

var $jcIvM = parcelRequire("jcIvM");

var $2aRm2 = parcelRequire("2aRm2");
function $1f2598c80baecd06$export$b98bf736a4892f95(interaction, experienceName) {
    const { start: start, type: type, marks: marks } = interaction;
    const config = (0, $jcIvM.getConfig)();
    const ssrDoneTime = config?.ssr?.getSSRDoneTime?.();
    const isBM3ConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp;
    const isUFOConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime;
    // Find matching legacy metric
    const matchingLegacyMetric = (0, $2aRm2.findMatchingLegacyMetric)(interaction, experienceName);
    let fmp;
    if (type === 'page_load' || type === 'transition') {
        if (interaction.legacyMetrics && matchingLegacyMetric) {
            // Check if legacy metric has FMP
            const legacyFmp = matchingLegacyMetric.fmp; // BM3Event doesn't have fmp in types, but it might exist
            if (legacyFmp) fmp = Math.round(legacyFmp - start);
        // If no FMP in legacy metric, return undefined (don't calculate fallback)
        }
    }
    if (type === 'page_load' && fmp === undefined) {
        if (isBM3ConfigSSRDoneAsFmp || isUFOConfigSSRDoneAsFmp) {
            const foundMark = marks?.find((mark)=>mark.name === 'fmp')?.time;
            if (foundMark) fmp = Math.round(foundMark - start);
            else if (ssrDoneTime) fmp = Math.round(ssrDoneTime - start);
        // If no FMP mark and no SSR done time, fmp remains undefined
        }
    }
    return fmp;
}

});
parcelRegister("2aRm2", function(module, exports) {

$parcel$export(module.exports, "findMatchingLegacyMetric", () => $329321948f38b554$export$9e0d04c44e1b23f6);
function $329321948f38b554$export$9e0d04c44e1b23f6(interaction, experienceName) {
    return interaction.legacyMetrics?.find((metric)=>(metric.key === experienceName || metric.config.reactUFOName === experienceName) && metric.type === 'PAGE_LOAD');
}

});


parcelRegister("jvGVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7e882a6836f5e2$export$2e2bcd8739ae039);
function $8f7e882a6836f5e2$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $8f7e882a6836f5e2$export$2e2bcd8739ae039 = $8f7e882a6836f5e2$var$getInteractionStatus;

});

parcelRegister("8XAiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5b3bbea0d247b87$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getNavigationMetricsToLegacyFormat", () => $c5b3bbea0d247b87$export$5f36f2643451c683);
function $c5b3bbea0d247b87$export$2e2bcd8739ae039(type) {
    if (type !== 'page_load') return null;
    try {
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        const navigation = entries[0];
        return {
            // From https://www.w3.org/TR/resource-timing/
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            // From https://www.w3.org/TR/navigation-timing-2/
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart),
            nextHopProtocol: navigation.nextHopProtocol
        };
    } catch (error) {
        // Return null if there's any error accessing navigation timing
        return null;
    }
}
function $c5b3bbea0d247b87$export$5f36f2643451c683(type) {
    const navigationMetrics = $c5b3bbea0d247b87$export$2e2bcd8739ae039(type);
    if (!navigationMetrics) return {};
    return {
        'metrics:navigation': navigationMetrics
    };
}

});

parcelRegister("bAhKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a42ff7463533a$export$2e2bcd8739ae039);

var $8tW4o = parcelRequire("8tW4o");
function $ad9a42ff7463533a$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $8tW4o.getPageVisibilityState)(start, end);
}
var $ad9a42ff7463533a$export$2e2bcd8739ae039 = $ad9a42ff7463533a$var$getPageVisibilityUpToTTAI;

});

parcelRegister("8PHbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e7cf4fdb591780$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPaintMetricsToLegacyFormat", () => $b1e7cf4fdb591780$export$3a01cabaa43622d);
async function $b1e7cf4fdb591780$export$2e2bcd8739ae039(type, end) {
    if (type !== 'page_load') return {};
    const paint = {};
    const paintEntries = performance.getEntriesByType('paint');
    paintEntries.forEach((entry)=>{
        if (entry.name === 'first-paint') paint.fp = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') paint.fcp = Math.round(entry.startTime);
    });
    // Get LCP using PerformanceObserver
    const lcp = await new Promise((resolve)=>{
        // Check if we already have LCP entries
        const existingEntries = performance.getEntriesByType('largest-contentful-paint');
        const lastEntry = existingEntries.reduce((agg, entry)=>{
            if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
            return agg;
        }, null);
        if (lastEntry) {
            resolve(lastEntry.startTime);
            return;
        }
        const observer = new PerformanceObserver((list)=>{
            const entries = Array.from(list.getEntries());
            const lastEntry = entries.reduce((agg, entry)=>{
                if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
                return agg;
            }, null);
            clearTimeout(timeoutId);
            observer.disconnect();
            if (lastEntry) resolve(lastEntry.startTime);
            else resolve(null);
        });
        observer.observe({
            type: 'largest-contentful-paint',
            buffered: true
        });
        const timeoutId = setTimeout(()=>{
            observer.disconnect();
            resolve(null);
        }, 200);
    });
    if (lcp) paint.lcp = Math.round(lcp);
    return paint;
}
async function $b1e7cf4fdb591780$export$3a01cabaa43622d(type, end) {
    const paint = await $b1e7cf4fdb591780$export$2e2bcd8739ae039(type, end);
    const legacyFormat = {};
    if (paint.fp !== undefined) legacyFormat['metric:fp'] = paint.fp;
    if (paint.fcp !== undefined) legacyFormat['metric:fcp'] = paint.fcp;
    if (paint.lcp !== undefined) legacyFormat['metric:lcp'] = paint.lcp;
    return legacyFormat;
}

});

parcelRegister("6ilbC", function(module, exports) {

$parcel$export(module.exports, "LATEST_REACT_UFO_PAYLOAD_VERSION", () => $c9f3d3949085e8be$export$e919e900fc2d7fe8);
$parcel$export(module.exports, "getReactUFOPayloadVersion", () => $c9f3d3949085e8be$export$159168550e7449b8);
const $c9f3d3949085e8be$export$e919e900fc2d7fe8 = '2.0.0';
function $c9f3d3949085e8be$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $c9f3d3949085e8be$export$e919e900fc2d7fe8;
}

});

parcelRegister("5G7DY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34a7c38f9473237$export$2e2bcd8739ae039);

var $gA3op = parcelRequire("gA3op");
function $e34a7c38f9473237$export$2e2bcd8739ae039(type) {
    if (type !== 'page_load') return undefined;
    return $gA3op.getSSRSuccess();
}

});

parcelRegister("7Qg5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d868487c9246c209$export$2e2bcd8739ae039);

var $bAhKB = parcelRequire("bAhKB");
function $d868487c9246c209$export$2e2bcd8739ae039(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $bAhKB.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}

});

parcelRegister("79aVI", function(module, exports) {

$parcel$export(module.exports, "getTTI", () => $9777a6fce377a8d2$export$84423319631a27a0);

var $2aRm2 = parcelRequire("2aRm2");
function $9777a6fce377a8d2$export$84423319631a27a0(interaction, experienceName) {
    const { start: start, end: end, apdex: apdex } = interaction;
    // Find matching legacy metric
    const matchingLegacyMetric = (0, $2aRm2.findMatchingLegacyMetric)(interaction, experienceName);
    // Get end times in priority order (following server-side logic)
    const apdexEndTime = apdex?.[0]?.stopTime;
    const legacyMetricsEndTime = matchingLegacyMetric?.stop;
    const ufoEndTime = end;
    let ttiEndTime;
    if (matchingLegacyMetric && legacyMetricsEndTime) // Use legacy metrics end time if we have a matching legacy metric
    ttiEndTime = legacyMetricsEndTime;
    else if (apdexEndTime) // Fall back to apdex end time if no matching legacy metrics
    ttiEndTime = apdexEndTime;
    else // Final fallback to UFO end time
    ttiEndTime = ufoEndTime;
    return ttiEndTime ? Math.round(ttiEndTime - start) : undefined;
}

});

parcelRegister("6fyPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1fb95f22ef955b$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $jcIvM = parcelRequire("jcIvM");

var $2QO3b = parcelRequire("2QO3b");

var $jvGVe = parcelRequire("jvGVe");

var $bAhKB = parcelRequire("bAhKB");

var $hmVXh = parcelRequire("hmVXh");
async function $3e1fb95f22ef955b$var$getVCMetrics(interaction) {
    const config = (0, $jcIvM.getConfig)();
    if (!config?.vc?.enabled) return {};
    if ((0, $eGOwo.fg)('platform_ufo_enable_vc_press_interactions')) {
        if (interaction.type !== 'page_load' && interaction.type !== 'transition' && interaction.type !== 'press') return {};
    } else {
        if (interaction.type !== 'page_load' && interaction.type !== 'transition') return {};
    }
    const interactionStatus = (0, $jvGVe.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $bAhKB.default)(interaction);
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible';
    // Use per-interaction VC observer if available, otherwise fall back to global
    const observer = interaction.vcObserver;
    if (!observer) return {};
    if (!shouldReportVCMetrics && (0, $eGOwo.fg)('platform_ufo_no_vc_on_aborted')) {
        observer.stop(interaction.ufoName);
        return {};
    }
    const isSSREnabled = interaction.type === 'page_load' && (config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName));
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $hmVXh.default)(config)
    } : null;
    (0, $2QO3b.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await observer.getVCResult({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        includeSSRInV3: config.vc?.includeSSRInV3,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        includeSSRRatio: config.vc?.includeSSRRatio,
        ...ssr
    });
    observer.stop(interaction.ufoName);
    (0, $2QO3b.postInteractionLog).setLastInteractionFinishVCResult(result);
    const mostRecentVCRevision = (0, $jcIvM.getMostRecentVCRevision)(interaction.ufoName);
    const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
    return {
        ...result,
        'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
    };
}
var $3e1fb95f22ef955b$export$2e2bcd8739ae039 = $3e1fb95f22ef955b$var$getVCMetrics;

});
parcelRegister("hmVXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $18931377f064fcc6$export$2e2bcd8739ae039);

var $gA3op = parcelRequire("gA3op");
function $18931377f064fcc6$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $gA3op.getSSRDoneTime();
}
var $18931377f064fcc6$export$2e2bcd8739ae039 = $18931377f064fcc6$var$getSSRDoneTimeValue;

});



parcelRegister("6pnNR", function(module, exports) {

$parcel$export(module.exports, "createSegmentMetricsPayloads", () => $1629b9f2b7ad75cd$export$267f7174399ab737);

var $jcIvM = parcelRequire("jcIvM");

var $exlmL = parcelRequire("exlmL");

var $bAhKB = parcelRequire("bAhKB");

var $6ilbC = parcelRequire("6ilbC");

var $kMpLw = parcelRequire("kMpLw");

var $9UIW7 = parcelRequire("9UIW7");

var $k3Vfm = parcelRequire("k3Vfm");
async function $1629b9f2b7ad75cd$export$267f7174399ab737(interactionId, interaction) {
    const config = (0, $jcIvM.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    // Get browser metadata (using compact nested format)
    const browserMetadata = (0, $exlmL.default)();
    // Process cohorting custom data
    const cohortingCustomData = interaction.cohortingCustomData?.size ? Object.fromEntries(interaction.cohortingCustomData) : undefined;
    const pageVisibilityAtTTAI = (0, $bAhKB.default)(interaction);
    const { knownSegments: knownSegments, reactProfilerTimings: reactProfilerTimings, rate: rate, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName } = interaction;
    // Group segments by name and select the first segment for each name
    const segmentsByName = new Map();
    for (const segment of knownSegments){
        const segmentId = (0, $9UIW7.default)(segment.labelStack);
        // skip if no segmentId
        if (!segmentId) continue;
        const name = segment.labelStack[segment.labelStack.length - 1].name;
        const isRootSegment = (0, $kMpLw.default)(segment.labelStack);
        const segmentProfilerTimings = reactProfilerTimings.filter((timing)=>{
            const timingSegmentId = (0, $9UIW7.default)(timing.labelStack);
            // check if labelStack matches exactly
            return timingSegmentId === segmentId;
        }).sort((a, b)=>{
            return a.startTime - b.startTime;
        });
        const firstMountTiming = segmentProfilerTimings.find((timing)=>{
            return timing.type === 'mount';
        });
        if (!firstMountTiming) continue;
        const firstMountTime = isRootSegment ? interaction.start : firstMountTiming.startTime;
        // Check if we already have a segment with this name
        const existingEntry = segmentsByName.get(name);
        if (!existingEntry || firstMountTime < existingEntry.firstMountTime) // Either first time seeing this name, or this segment mounted earlier
        segmentsByName.set(name, {
            segment: segment,
            firstMountTime: firstMountTime
        });
    }
    // Create payloads only for the selected segments (first one per name)
    const payloads = [];
    for (const { segment: segment } of segmentsByName.values()){
        const segmentId = (0, $9UIW7.default)(segment.labelStack);
        const name = segment.labelStack[segment.labelStack.length - 1].name;
        const isRootSegment = (0, $kMpLw.default)(segment.labelStack);
        const segmentProfilerTimings = reactProfilerTimings.filter((timing)=>{
            const timingSegmentId = (0, $9UIW7.default)(timing.labelStack);
            // check if labelStack matches exactly
            return timingSegmentId === segmentId;
        }).sort((a, b)=>{
            return a.startTime - b.startTime;
        });
        const firstMountTiming = segmentProfilerTimings.find((timing)=>{
            return timing.type === 'mount';
        });
        // We already checked this exists in the grouping phase
        if (!firstMountTiming) continue;
        const lastTiming = segmentProfilerTimings[segmentProfilerTimings.length - 1];
        const startTime = isRootSegment ? interaction.start : firstMountTiming.startTime;
        const endTime = lastTiming.commitTime;
        const ttai = Math.round(endTime - startTime);
        const { status: status, abortReason: segmentAbortReason } = (0, $k3Vfm.default)(interaction, segment);
        if (status !== 'SUCCEEDED') continue;
        const properties = {
            // Basic metadata
            'event:hostname': window.location?.hostname || 'unknown',
            'event:product': config.product,
            'event:schema': '1.0.0',
            'event:region': config.region || 'unknown',
            'event:source': {
                name: 'react-ufo/web',
                version: (0, $6ilbC.LATEST_REACT_UFO_PAYLOAD_VERSION)
            },
            'experience:key': 'custom.ufo.critical-metrics',
            'experience:name': name,
            // Browser metadata (compact nested format)
            browser: browserMetadata.browser,
            device: browserMetadata.device,
            network: browserMetadata.network,
            time: browserMetadata.time,
            metrics: {
                ttai: ttai,
                tti: ttai
            },
            interactionId: interactionId,
            type: 'page_segment_load',
            rate: rate,
            routeName: routeName ?? undefined,
            // Performance timings
            start: Math.round(startTime),
            end: Math.round(endTime),
            status: // Status and outcome
            status,
            abortReason: segmentAbortReason,
            previousInteractionName: previousInteractionName,
            isPreviousInteractionAborted: isPreviousInteractionAborted,
            abortedByInteractionName: abortedByInteractionName,
            pageVisibilityAtTTAI: pageVisibilityAtTTAI,
            // Basic error count (not detailed error count)
            errorCount: interaction.errors.length,
            // Cohorting custom data
            ...Object.keys(cohortingCustomData || {}).length > 0 && {
                cohortingCustomData: cohortingCustomData
            }
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            eventType: 'operational',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: properties
            }
        };
        payloads.push(payload);
    }
    return payloads;
}

});
parcelRegister("kMpLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e4ce771383b98c$export$2e2bcd8739ae039);
function $74e4ce771383b98c$export$2e2bcd8739ae039(labelStack) {
    return labelStack.length === 1;
}

});

parcelRegister("9UIW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb44a699d532b4a$export$2e2bcd8739ae039);
function $8bb44a699d532b4a$export$2e2bcd8739ae039(labelStack) {
    for(let i = labelStack.length - 1; i >= 0; i--){
        const label = labelStack[i];
        if ('segmentId' in label) return label.segmentId;
    }
    return undefined;
}

});

parcelRegister("k3Vfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $92483e06cd22c69b$export$2e2bcd8739ae039);

var $jvGVe = parcelRequire("jvGVe");

var $9UIW7 = parcelRequire("9UIW7");

var $ejtpu = parcelRequire("ejtpu");

var $aaN60 = parcelRequire("aaN60");
function $92483e06cd22c69b$export$2e2bcd8739ae039(interaction, segment) {
    const segmentId = (0, $9UIW7.default)(segment.labelStack);
    // Get the root interaction status info
    const rootInteractionStatus = (0, $jvGVe.default)(interaction);
    const rootStatus = rootInteractionStatus.originalInteractionStatus;
    const rootAbortReason = interaction.abortReason;
    const isInteractionsAbortedByNewInteraction = rootStatus === 'ABORTED' && rootAbortReason === 'new_interaction';
    const isInteractionsAbortedByTransition = rootStatus === 'ABORTED' && rootAbortReason === 'transition';
    let status = 'SUCCEEDED';
    let abortReason;
    // Check if this specific segment has failed
    if (segmentId && (0, $ejtpu.default)(interaction.errors, segmentId)) status = 'FAILED';
    else if (isInteractionsAbortedByNewInteraction) {
        status = 'ABORTED';
        abortReason = 'new_interaction';
    } else if (isInteractionsAbortedByTransition) {
        status = 'ABORTED';
        abortReason = 'transition';
    } else if (segmentId) {
        // Check for active holds that are under this segment
        for (const activeHold of interaction.holdActive.values())if ((0, $aaN60.default)(activeHold.labelStack, segmentId)) {
            status = 'ABORTED';
            abortReason = 'timeout';
            break;
        }
    }
    return {
        status: status,
        abortReason: abortReason
    };
}

});
parcelRegister("ejtpu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f2f6f5e32c1b8cd$export$2e2bcd8739ae039);

var $9UIW7 = parcelRequire("9UIW7");
function $4f2f6f5e32c1b8cd$export$2e2bcd8739ae039(errors, segmentId) {
    return errors.some((error)=>{
        if (!error.labelStack) return false;
        const errorSegmentId = (0, $9UIW7.default)(error.labelStack);
        return errorSegmentId === segmentId;
    });
}

});

parcelRegister("aaN60", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b81213ea1097e0$export$2e2bcd8739ae039);
function $37b81213ea1097e0$export$2e2bcd8739ae039(labelStack, segmentId) {
    return labelStack.some((label)=>{
        return 'segmentId' in label && label.segmentId === segmentId;
    });
}

});




parcelRegister("lAaBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $789f3ac5021170c5$export$2e2bcd8739ae039);
// Reusable TextEncoder instance to avoid creating new instances
const $789f3ac5021170c5$var$textEncoder = new TextEncoder();
function $789f3ac5021170c5$export$2e2bcd8739ae039(payload) {
    // Early return for null/undefined to avoid unnecessary processing
    if (!payload) return 0;
    // Use the reusable encoder instance
    return Math.round($789f3ac5021170c5$var$textEncoder.encode(JSON.stringify(payload)).length / 1024);
}

});



//# sourceMappingURL=create-payloads.b15dd922.js.map
